<template>
  <div class="content content-fixed content-auth">
    <div class="container">
      <div class="media align-items-stretch justify-content-center ht-100p">
        <div class="sign-wrapper reg-wrapper mg-lg-r-50 mg-xl-r-60">
          <div class="wd-100p">
            <div class="form-group mg-b-10" v-if="tmzExam">
              <label class="mg-b-0-f">Одоогийн төлөв сонгоно уу</label>
              <div class="d-flex">
                <Select
                  @change="locTypeId4Changed"
                  v-model="form.profileModel.locTypeId4"
                  class="wd-100p"
                  placeholder="-- Сонгоно уу --"
                  clearable
                >
                  <Option label="Оюутан" :value="81185"></Option>
                  <Option label="Нягтлан бодогч" :value="81190"></Option>
                </Select>
              </div>
            </div>

            <template
              v-if="
                //$store.state.app.activeGroup.register &&
                showRegFromHomeSettings &&
                  !hideForm &&
                  ($store.state.app.activeGroup.id == 9265 ||
                    $store.state.app.activeGroup.id == 9254 ||
                    $store.state.app.activeGroup.id == 9311)
              "
            >
              <div
                v-if="
                  $store.state.app.isMobile &&
                    $store.state.app.activeGroup.id == 9254
                "
              >
                <b-modal
                  title="Бүртгүүлэх заавар"
                  v-model="registerHelpModal"
                  no-close-on-backdrop
                  scrollable
                  hide-footer
                  size="lg"
                  body-class="pd-0"
                >
                  <iframe
                    width="100%"
                    height="400"
                    src="https://www.youtube-nocookie.com/embed/UfN4V7llkwY?si=s399zSg86IgC6UPZ"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </b-modal>
                <button
                  class="btn btn-brand-02 btn-block mg-b-10"
                  @click="registerHelpModal = true"
                >
                  Бүртгүүлэх заавар үзэх
                </button>
              </div>
              <div class="form-group mg-b-10">
                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">Нэвтрэх нэр</label>
                  <input
                    v-model="form.userLogin"
                    type="text"
                    class="form-control"
                    placeholder="Нэвтрэх нэрээ оруулна уу"
                  />
                </div>
                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">И-мэйл хаяг</label>
                  <input
                    v-model="form.userMail"
                    @input="validateEmail"
                    type="email"
                    class="form-control"
                    placeholder="И-мэйл хаягаа оруулна уу"
                  />
                </div>
                <div class="divider-text">Хэрэглэгчийн мэдээлэл</div>
                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">Эцэг/эх-н нэр</label>
                  <input
                    v-model="form.userOvog"
                    @input="validateIsCryllic('userOvog')"
                    type="text"
                    class="form-control"
                    placeholder="Эцэг/эх-н нэр оруулна уу"
                  />
                </div>
                <div class="form-group">
                  <label class="mg-b-0-f">Нэр</label>
                  <input
                    v-model="form.userNer"
                    @input="validateIsCryllic('userNer')"
                    type="text"
                    class="form-control"
                    placeholder="Нэрээ оруулна уу"
                  />
                </div>

                <div
                  class="form-group mg-b-10"
                  :style="
                    `${
                      $store.state.app.activeGroup.id == 9254
                        ? ''
                        : 'display: none'
                    }`
                  "
                >
                  <label class="mg-b-0-f">Регистр №</label>
                  <div class="d-flex">
                    <Select
                      v-model="form.userRegA"
                      style="width: 60px"
                      placeholder="А"
                      clearable
                      filterable
                    >
                      <Option
                        v-for="(item, i) in crylChars"
                        :label="item.toUpperCase()"
                        :value="item"
                        :key="i + '_regA'"
                        >{{ item.toUpperCase() }}</Option
                      >
                    </Select>
                    <Select
                      v-model="form.userRegB"
                      style="width: 60px"
                      placeholder="Б"
                      clearable
                      filterable
                    >
                      <Option
                        v-for="(item, i) in crylChars"
                        :label="item.toUpperCase()"
                        :value="item"
                        :key="i + '_regB'"
                        >{{ item.toUpperCase() }}</Option
                      >
                    </Select>
                    <input
                      v-model="form.userRegister"
                      maxlength="8"
                      type="text"
                      @keypress="validateRegister($event)"
                      class="form-control wd-60p"
                      placeholder="Регистр № оруулна уу"
                    />
                  </div>
                  <div class="alert alert-info mg-t-10" role="alert">
                    Таны РД бүртгэлийн код болох тул та үнэн зөв бөглөнө үү.
                    Жишээ нь: ЕЗ86042406
                  </div>
                </div>

                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">Хүйс</label>
                  <loc-type-cascader
                    v-model="form.profileModel.locTypeId1"
                    locTypekey="sysGlobalRefGender"
                    class="wd-100p"
                    disableAdd
                  />
                </div>

                <div
                  class="form-group mg-b-10"
                  v-if="$store.state.app.activeGroup.id == 9254"
                >
                  <label class="mg-b-0-f">Байршил</label>
                  <loc-type-cascader
                    v-model="form.profileModel.locTypeId13"
                    locTypekey="sysRefProvince"
                    class="wd-100p"
                    disableAdd
                  />
                </div>

                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">Байгууллага</label>
                  <template v-if="$store.state.app.activeGroup.id == 9254">
                    <depart-cascader2
                      :checkStrictly="true"
                      :pid="depParentId"
                      @on-change-3="departChanged"
                    />
                  </template>
                  <Select
                    v-else
                    v-model="form.profileModel.departId"
                    @change="departChanged"
                    class="wd-100p"
                  >
                    <Option
                      v-for="(d, i) in departs"
                      :key="i"
                      :value="d.id"
                      :label="
                        d.shortName == 'disabled' ? `-- ${d.label} --` : d.label
                      "
                      :disabled="d.shortName == 'disabled'"
                    ></Option>
                  </Select>
                </div>
                <div v-if="dpOther" class="form-group mg-b-10">
                  <label class="mg-b-0-f"
                    >Одоо ажиллаж буй ажлын газрын нэр</label
                  >
                  <input
                    v-model="form.profileModel.s6"
                    type="text"
                    class="form-control"
                    placeholder="Одоо ажиллаж буй ажлын газрын нэр бичнэ үү"
                  />
                </div>
                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">Газар/Хэлтэс/Алба</label>
                  <input
                    v-model="form.profileModel.s7"
                    @input="validateProfileIsCryllic('s7')"
                    type="text"
                    class="form-control"
                    placeholder="Газар/Хэлтэс/Алба"
                  />
                </div>

                <div
                  class="form-group mg-b-10"
                  v-if="$store.state.app.activeGroup.id == 9254"
                >
                  <label class="mg-b-0-f">Албан тушаалын ангилал</label>
                  <loc-type-cascader
                    v-model="form.profileModel.locTypeId14"
                    locTypekey="hrmPosCat"
                    class="wd-100p"
                    disableAdd
                  />
                </div>
                <div
                  class="form-group mg-b-10"
                  v-if="$store.state.app.activeGroup.id == 9254"
                >
                  <label class="mg-b-0-f">Албан тушаалын төрөл</label>
                  <loc-type-cascader
                    v-model="form.profileModel.locTypeId15"
                    locTypekey="hrmPosLvl"
                    class="wd-100p"
                    disableAdd
                  />
                </div>
                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">Албан тушаал</label>
                  <input
                    @input="validateIsCryllic('userPosition')"
                    v-model="form.userPosition"
                    type="text"
                    class="form-control"
                    placeholder="Албан тушаал бичнэ үү"
                  />
                </div>

                <div
                  class="form-group mg-b-10"
                  v-if="$store.state.app.activeGroup.id == 9265"
                >
                  <label class="mg-b-0-f">Түвшин</label>
                  <loc-type-cascader
                    v-model="form.profileModel.locTypeId11"
                    locTypekey="bfaLevel"
                    class="wd-100p"
                    disableAdd
                  />
                </div>

                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">Утасны №</label>
                  <input
                    v-model="form.userUtas"
                    maxlength="8"
                    type="text"
                    @keypress="validateRegister($event)"
                    class="form-control"
                    placeholder="Утасны дугаараа оруулна уу"
                  />
                </div>

                <template>
                  <div class="form-group mg-b-10">
                    <!-- {{privacyPolicy}} -->
                    <label for="pp" class="mg-b-0-f"
                      ><input id="pp" type="checkbox" v-model="privacyPolicy" />
                      Би үйлчилгээний нөхцөлийг уншиж танилцан
                    </label>
                    <a
                      class="tx-primary"
                      @click="showPrivacyPolicy()"
                      role="button"
                      >зөвшөөрч байна</a
                    >
                  </div>
                </template>
              </div>
            </template>
            <!-- $store.state.app.activeGroup.register -->
            <template v-else-if="showRegFromHomeSettings && !hideForm">
              <div
                class="form-group d-flex align-items-center mg-b-10"
                v-if="!hideRegister"
              >
                <label class="mg-b-0-f lh-1 wd-300">Регистр №</label>
                <div class="d-flex align-items-center wd-100p">
                  <Select
                    v-model="form.userRegA"
                    style="width: 60px"
                    placeholder="А"
                    clearable
                    filterable
                  >
                    <Option
                      v-for="(item, i) in crylChars"
                      :label="item.toUpperCase()"
                      :value="item"
                      :key="i + '_regA'"
                      >{{ item.toUpperCase() }}</Option
                    >
                  </Select>
                  <Select
                    v-model="form.userRegB"
                    style="width: 60px"
                    placeholder="Б"
                    clearable
                    filterable
                  >
                    <Option
                      v-for="(item, i) in crylChars"
                      :label="item.toUpperCase()"
                      :value="item"
                      :key="i + '_regB'"
                      >{{ item.toUpperCase() }}</Option
                    >
                  </Select>
                  <input
                    v-model="form.userRegister"
                    maxlength="8"
                    type="text"
                    @keypress="validateRegister($event)"
                    class="form-control wd-60p"
                    placeholder="Регистр № оруулна уу"
                  />
                </div>
              </div>
              <div class="form-group mg-b-10 d-flex align-items-center">
                <label class="mg-b-0-f lh-1 wd-300">Эцэг /эх/-ийн нэр</label>
                <input
                  v-model="form.userOvog"
                  type="text"
                  class="form-control"
                  placeholder="Эцэг /эх/-ийн нэр оруулна уу"
                />
              </div>
              <div class="form-group mg-b-10 d-flex align-items-center">
                <label class="mg-b-0-f lh-1 wd-300">Нэр</label>
                <input
                  v-model="form.userNer"
                  type="text"
                  class="form-control"
                  placeholder="Нэрээ оруулна уу"
                />
              </div>
              <div class="form-group mg-b-10 d-flex align-items-center">
                <label class="mg-b-0-f lh-1 wd-300">Утасны дугаар</label>
                <input
                  v-model="form.userUtas"
                  maxlength="8"
                  type="text"
                  @keypress="validateRegister($event)"
                  class="form-control"
                  placeholder="Утасны дугаараа оруулна уу"
                />
              </div>
              <div class="form-group  mg-b-10 d-flex align-items-center">
                <label class="mg-b-0-f lh-1 wd-300">{{
                  getLoginLabel()
                }}</label>
                <div class="wd-100p">
                  <input
                    v-if="$store.state.app.activeGroup.id == 9298"
                    v-model="form.userLogin"
                    type="number"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    maxlength="12"
                    class="form-control"
                    :placeholder="`${getLoginLabel()} оруулна уу`"
                  />
                  <input
                    v-else
                    v-model="form.userLogin"
                    type="text"
                    class="form-control"
                    :placeholder="`${getLoginLabel()} оруулна уу`"
                  />
                  <div v-if="$store.state.app.activeGroup.id == 9298" class="">
                    <div
                      class="lh-1 pd-l-10 mg-y-5 bd-l bd-2 bd-white tx-italic"
                    >
                      Иргэний бүртгэлийн дугаар харах боломжууд
                    </div>
                    <div class="pos-relative pd-l-30">
                      <ul>
                        <li>Иргэний үнэмлэхний QR уншуулах</li>
                        <li class="lh-1">
                          e-Mongolia цахим системээс /бүртгэлийн дугаар/
                        </li>
                        <li class="lh-1">
                          И-баримт апп-с /ТТД эсвэл Иргэний код/
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="isStartUp()">
                <div class="form-group mg-b-10">
                  <label for="ppg" class="mg-b-0-f">
                    <input id="ppg" type="checkbox" v-model="tempQualityPerc" />
                    Гарааны компани эсэх
                  </label>
                </div>
              </template>
              <div class="form-group mg-b-10 d-flex align-items-center">
                <label class="mg-b-0-f lh-1 wd-300">И-мэйл хаяг</label>
                <input
                  v-model="form.userMail"
                  type="email"
                  class="form-control"
                  placeholder="И-мэйл хаягаа оруулна уу"
                />
              </div>
              <div class="form-group mg-b-10 d-flex align-items-center">
                <label class="mg-b-0-f lh-1 wd-300"
                  >И-мэйл хаяг давтана уу</label
                >
                <input
                  v-model="form.userMailRe"
                  type="email"
                  class="form-control"
                  placeholder="И-мэйл хаягаа давтан оруулна уу"
                />
              </div>
              <div
                class="form-group mg-b-10 d-flex align-items-center"
                v-if="$store.state.app.activeGroup.id == 9298"
              >
                <label class="mg-b-0-f lh-1 wd-300">Хувийн и-мэйл хаяг</label>
                <input
                  v-model="form.userMailOwn"
                  type="email"
                  class="form-control"
                  placeholder="Хувийн и-мэйл хаяг оруулна уу"
                />
              </div>

              <div
                class="form-group mg-b-10 d-flex align-items-center"
                v-if="$store.state.app.activeGroup.id == 9260"
              >
                <label class="mg-b-0-f lh-1 wd-300">Хэлтэс</label>
                <Select
                  v-model="form.profileModel.departId"
                  @change="departChanged"
                  class="wd-100p"
                >
                  <Option
                    v-for="(d, i) in departs"
                    :key="i"
                    :value="d.id"
                    :label="d.label"
                  ></Option>
                </Select>
              </div>

              <template v-if="tmzExam">
                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">Хүйс</label>
                  <loc-type-cascader
                    v-model="form.profileModel.locTypeId1"
                    locTypekey="sysGlobalRefGender"
                    class="wd-100p"
                    disableAdd
                  />
                </div>
                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">{{
                    form.profileModel.locTypeId4 == 81190
                      ? "Одоо ажиллаж буй аймаг/дүүрэг, сум"
                      : "Үндсэн захиргаа /төрсөн аймаг, дүүрэг, сум"
                  }}</label>
                  <loc-type-cascader
                    v-model="form.profileModel.locTypeId3"
                    locTypekey="sysRefProvince"
                    class="wd-100p"
                    disableAdd
                  />
                </div>
                <template v-if="form.profileModel.locTypeId4 == 81190">
                  <div class="form-group mg-b-10">
                    <label class="mg-b-0-f"
                      >Одоо ажиллаж буй ажлын газрын нэр</label
                    >
                    <input
                      v-model="form.userPosition"
                      type="text"
                      class="form-control"
                      placeholder="Одоо ажиллаж буй ажлын газрын нэр"
                    />
                  </div>
                  <div class="form-group mg-b-10">
                    <label class="mg-b-0-f"
                      >Нягтлан бодогчоор төсөвт байгууллагад ажилласан
                      жил</label
                    >
                    <input
                      v-model="form.profileModel.i6"
                      type="number"
                      class="form-control"
                      placeholder="Нягтлан бодогчоор төсөвт байгууллагад ажилласан жил"
                    />
                  </div>
                </template>
                <template v-else-if="form.profileModel.locTypeId4 == 81185">
                </template>

                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">{{
                    form.profileModel.locTypeId4 == 81190
                      ? "Нягтлан бодогч мэргэжлээр төгссөн сургуулийн нэр"
                      : "Их, дээд сургуулийн нэр"
                  }}</label>
                  <input
                    v-model="form.profileModel.s15"
                    type="text"
                    class="form-control"
                    :placeholder="
                      form.profileModel.locTypeId4 == 81190
                        ? 'Нягтлан бодогч мэргэжлээр төгссөн сургуулийн нэр'
                        : 'Их, дээд сургуулийн нэр'
                    "
                  />
                </div>
                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">{{
                    form.profileModel.locTypeId4 == 81190
                      ? "Нягтлан бодогч мэргэжлээр төгссөн он"
                      : "Их, дээд сургуульд элссэн он"
                  }}</label>
                  <input
                    v-model="form.profileModel.i7"
                    type="number"
                    class="form-control"
                    :placeholder="
                      form.profileModel.locTypeId4 == 81190
                        ? 'Нягтлан бодогч мэргэжлээр төгссөн он'
                        : 'Их, дээд сургуульд элссэн он'
                    "
                  />
                </div>
              </template>
              <template v-else-if="$store.state.app.activeGroup.id != 9298">
                <div class="form-group mg-b-10">
                  <label class="mg-b-0-f">Оршин суугаа хаяг</label>
                  <textarea
                    v-model="form.userAddress"
                    class="form-control"
                    placeholder="Оршин суугаа хаягаа бичнэ үү"
                    rows="2"
                  ></textarea>
                </div>
              </template>

              <template>
                <div class="form-group mg-b-10">
                  <!-- {{privacyPolicy}} -->

                  <div class="d-flex">
                    <label for="pp" class="mg-b-0-f"
                      ><input id="pp" type="checkbox" v-model="privacyPolicy" />
                      Би үйлчилгээний нөхцөлийг уншиж танилцан
                    </label>
                    <a
                      class="tx-primary mg-l-10 link-and-white"
                      @click="showPrivacyPolicy()"
                      role="button"
                      >зөвшөөрч байна</a
                    >
                  </div>
                </div>
              </template>
            </template>
            <!-- <button class="btn btn-outline-facebook btn-block">Sign Up With Facebook</button>
            <button class="btn btn-outline-twitter btn-block">Sign Up With Twitter</button>-->

            <div class="d-flex align-items-center justify-content-end">
              <button @click="register()" class="btn btn-brand-02">
                Бүртгүүлэх
              </button>
              <div class="divider-text w-auto">эсвэл</div>
              <div class="tx-13 tx-center">
                Танд бүртгэл байгаа бол?
                <a
                  v-if="tmzExam"
                  @click="exmLogin()"
                  class="btn btn-info btn-xs"
                  role="button"
                  >Нэвтрэх</a
                >
                <router-link class="link-and-white" v-else to="/login"
                  >Нэвтрэх</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <!-- sign-wrapper -->
        <div
          :class="
            `
            media-body
            pd-y-30 pd-lg-x-50 pd-xl-x-60
            
            d-none d-lg-flex
            pos-relative ${
              $store.state.app.activeGroup.id == 9254
                ? ''
                : 'align-items-center'
            }`
          "
        >
          <div class="text-center">
            <!-- $store.state.app.activeGroup.register -->
            <div class="text-left" v-if="showRegFromHomeSettings">
              <h4
                :class="
                  `${
                    $store.state.app.activeGroup.id == 9254
                      ? 'tx-color-04'
                      : 'tx-color-01'
                  } mg-b-5`
                "
              >
                Бүртгэл үүсгэх
              </h4>
              <p class="tx-color-03 tx-16 mg-b-20">Динамик аккаунт үүсгэх.</p>
            </div>

            <template v-if="$store.state.app.activeGroup.id == 9254">
              <iframe
                width="600"
                height="400"
                src="https://www.youtube-nocookie.com/embed/UfN4V7llkwY?si=s399zSg86IgC6UPZ"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </template>
            <template v-else>
              <div class="mx-lg-wd-200 mx-xl-wd-250 mx-wd-300">
                <img
                  src="/assets/img/img16.png"
                  class="img-fluid"
                  style="max-height: 40vh"
                  alt
                />
              </div>
            </template>

            <div class="pos-absolute b-0 r-0 tx-12">
              <a target="_blank" href="https://www.gosmart.mn"
                >Powered by Dynamic Platform</a
              >
            </div>
          </div>
        </div>
        <!-- media-body -->
      </div>
      <!-- media -->
    </div>
    <b-modal
      title="Үйлчилгээний нөхцөл"
      v-model="privacyPolicyModal"
      no-close-on-backdrop
      scrollable
      hide-footer
      size="lg"
    >
      <div class="pd-20">
        <p><strong>НУУЦЛАЛЫН БОДЛОГО</strong></p>
        <p>
          Хэрэглэгчийн хувийн болон, ашиглаж буй бүтээгдэхvvн үйлчилгээтэй
          холбоотой бvх төрлийн мэдээллийн халдашгүй байдлыг хангах, хамгаалах
          нь Динамик платформ ашиглан үйлчилгээ үзүүлэгчийн үүрэг болно.
          "Нууцлалын бодлого" нь Хэрэглэгчийн мэдээллийг хадгалах, хамгаалахтай
          холбоотой хэрэгжүүлэх бодлого юм.
        </p>
        <p><strong>ЕРӨНХИЙ ЗҮЙЛ</strong></p>
        <ol>
          <li>
            Динамик платформыг ашигласнаар таныг уг Нууцлалын бодлогын
            нөхцөлүүдийг зөвшөөрсөн гэж үзнэ. Хуульд өөрчлөлт орох, эсвэл хувийн
            мэдээлэл цуглуулах, ашиглах бидний практик үйл ажиллагаанд өөрчлөлт
            орсон тохиолдолд Динамик платформ нь энэхүү Нууцлалын бодлогод
            өөрчлөлт оруулж болно. Шинэчлэгдсэн нууцлалын бодлогыг
            https://www.gosmart.mn вэб хуудсанд байршуулан тухайн өөрчлөлтийг
            хэрэглэгчдэд мэдэгдэж &ldquo;[Сүүлд шинэчилсэн:]&rdquo; гэх огноог
            өөрчилнө. Нууцлалын бодлогод хийгдсэн өөрчлөлтүүд нь вэб сайтад
            нийтлэгдсэн үеээс хүчин төгөлдөр үйлчилнэ. Хэрэглэгч та шинэчлэгдсэн
            нөхцөлийг вэб сайтад нийтлэгдсэн, эсвэл хэрэглэгчдэд мэдээлснээс
            хойш Динамик платформын үйлчилгээг үргэлжлүүлэн ашиглавал тэдгээрийг
            хүлээн зөвшөөрсөнд тооцогдоно.
          </li>
          <li>
            Хэрэглэгчийн Динамик платформд оруулсан бүх мэдээ, мэдээллийг нууц
            мэдээ мэдээлэлд хамруулна.
          </li>
          <li>
            Мэдээллийн хадгалах хэлбэрээс үл хамааран мэдээ, мэдээллийн нууцыг
            тухай бүр тохирсон арга, хэлбэрээр чандлан хамгаалах, задруулахгүй
            байх бүх арга хэмжээг авна.
          </li>
          <li>
            Хэрэглэгчийн зүгээс өөрийн платформд нэвтрэх хаяг, хувийн мэдээлэл
            болон нууц үгийг чандлан хадгалах, бусдад дамжуулахгүй байх
            үүрэгтэй.
          </li>
        </ol>
        <p><strong>МЭДЭЭЛЛИЙН ТӨРӨЛ</strong></p>
        <ul>
          <li>
            Хэрэглэгчийн бүртгэл үүсгэхтэй холбоотой үүссэн бүх төрлийн мэдээлэл
          </li>
          <li>
            Динамик цахим сургалтын платформ ашиглахтай холбогдон үүссэн бүх
            төрлийн тайлан, статистик, дүн, мэдээ
          </li>
        </ul>
        <p>
          Дээрх бүх төрлийн мэдээллийн аюулгүй байдлыг Хувь хүний нууцын тухай
          болон Кибер аюулгүй байдлын тухай хуульд нийцүүлэн, чандлан хадгалж,
          хөндлөнгийн этгээдэд задруулахгүй, хамгаалах боломжит бүх арга хэмжээг
          авна.
        </p>
        <p><strong>БАТАЛГАА</strong></p>
        <ol>
          <li>
            Динамик платформ ашиглан үйлчилгээ үзүүлэгч нь үйл ажиллагаа явуулах
            хууль ёсны зөвшөөрөлтэй, энэхүү бодлогыг хэрэгжүүлэх, аливаа хэлцэл
            хийх чадвартай байна.
          </li>
          <li>
            Холбогдох хууль тогтоомжид заасан бусад үндэслэл болон, хэрэглэгч
            тал өөрийн нууц мэдээллийг задруулахаар бичгээр зөвшөөрснөөс бусад
            тохиолдолд хэрэглэгчийн нууц мэдээллийг ашиглах болон бусдад гаргаж
            өгч, ашиглуулахгүй.
          </li>
        </ol>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ</p>
        <p>
          ДИНАМИК ПЛАТФОРМЫГ СОНГОН АШИГЛАЖ БАЙГАА ТАНД БАЯРЛАЛАА. ДИНАМИК
          ПЛАТФОРМЫН ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ НЬ ҮЙЛЧИЛГЭЭТЭЙ ХОЛБООТОЙ ХАРИЛЦААГ
          ЗОХИЦУУЛНА. ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛТЭЙ ТАНИЛЦАЖ, ЗӨВШӨӨРСНӨӨР ҮЙЛЧИЛГЭЭТЭЙ
          ХОЛБООТОЙ ХАРИЛЦААНД ОРОЛЦОХ ЭРХ, ҮҮРЭГ, ХАРИУЦЛАГЫГ ХҮЛЭЭХЭЭР ТАЛУУД
          ТОХИРОЛЦСОНД ТООЦОГДОНО.
        </p>
        <p>
          БИДНИЙ ҮЙЛЧИЛГЭЭГ АШИГЛАХААСАА ӨМНӨ ТА ЭНЭХҮҮ ГЭРЭЭНД ЗААСАН
          НӨХЦӨЛҮҮДИЙГ САЙТАР УНШИЖ ТАНИЛЦАНА УУ.
        </p>
        <p>НЭГ. ЕРӨНХИЙ НӨХЦӨЛ</p>
        <ol>
          <li>
            Үйлчилгээний нөхцөл нь нэг талаас Динамик платформын аюулгүй,
            найдвартай байдлыг ханган Хэрэглэгчийн мэдээллийг хадгалах,
            хамгаалах Үйлчилгээ үзүүлэгчийн, нөгөө талаас Үйлчилгээг ашиглан
            цахим сургалтад хамрагдах Хэрэглэгчийн хооронд үүсэх бүх төрлийн
            харилцааг зохицуулна.
          </li>
          <li>
            Энэхүү үйлчилгээний нөхцөлд дурьдсан нэр томъёог дараахь утгаар
            ойлгоно. Үүнд:
          </li>
        </ol>
        <ul>
          <li>Динамик платформ - цахим сургалтын платформ</li>
          <li>
            Үйлчилгээ - Динамик цахим сургалтын платформыг ашигласнаар авах
            үйлчилгээ
          </li>
          <li>
            Үйлчилгээ үзүүлэгч - Динамик платформоор дамжуулан цахим сургалтын
            үйл ажиллагаа явуулж буй тал
          </li>
          <li>
            Үйлчилгээний нөхцөл - Үйлчилгээтэй холбоотой харилцааг зохицуулах
            баримт бичиг
          </li>
          <li>
            Хэрэглэгч - Динамик платформд бүртгэл үүсгэн ашиглаж буй хувь хүн
            эсвэл, хуулийн этгээдийг төлөөлөгч хүн
          </li>
          <li>Талууд - Үйлчилгээ үзүүлэгч болон үйлчилгээ авч буй хэрэглэгч</li>
          <li>
            Хэрэглэгчийн мэдээлэл - Хэрэглэгчийн Динамик платформд оруулсан
            хувийн мэдээлэл болон, үйлчилгээ авахтай холбоотой үүссэн мэдээлэл
          </li>
        </ul>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <ol start="3">
          <li>
            Тус үйлчилгээний нөхцөл нь хэрэглэгч та танилцан хүлээн зөвшөөрч,
            динамик платформ сайт болон аппликейшн - д бүртгүүлсэн өдрөөс хүчин
            төгөлдөр үйлчилнэ.
          </li>
        </ol>
        <p>&nbsp;</p>
        <ol start="4">
          <li>
            Хэрэглэгч үйлчилгээний нөхцлийг анхааралтай уншиж танилцах үүргээ
            зохих ёсоор гүйцэтгээгүй нь Үйлчилгээний нөхцөл, түүний аливаа
            заалтыг танилцаагүй, мэдээгүй, хүлээн зөвшөөрөхгүй гэж үзэх, эсхүл
            Хэрэглэгчийг аливаа үүрэг, хариуцлагаас чөлөөлөх үндэслэл болохгүй.
          </li>
          <li>
            Динамик платформ нь энэхүү үйлчилгээний нөхцөлд хэдийд ч нэмэлт,
            өөрчлөлт оруулах бүрэн эрхтэй бөгөөд шинэчлэгдсэн Үйлчилгээний
            нөхцөлийг https://www.gosmart.mn вэб хуудсанд байршуулан тухайн
            өөрчлөлтийг хэрэглэгчдэд мэдэгдэж &ldquo;[Сүүлд шинэчилсэн:]&rdquo;
            гэх огноог өөрчилнө. Үйлчилгээний нөхцөлд хийгдсэн өөрчлөлтүүд нь
            вэб сайтад нийтлэгдсэн үеээс хүчин төгөлдөр үйлчилнэ. Хэрэглэгч та
            шинэчлэгдсэн нөхцөлийг вэб сайтад нийтлэгдсэн, эсвэл хэрэглэгчдэд
            мэдээлснээс хойш Динамик платформын үйлчилгээг үргэлжлүүлэн
            ашиглавал тэдгээрийг хүлээн зөвшөөрсөнд тооцогдоно.
          </li>
        </ol>
        <p>&nbsp;</p>
        <p>ХОЁР. ДИНАМИК ПЛАТФОРМЫН ҮЙЛ АЖИЛЛАГАА</p>
        <ol>
          <li>Динамик платформ сайт болон аппликейшн нь :</li>
        </ol>
        <ul>
          <li>
            Контентуудыг хэрэглэгчдэд хүргэж буй платформыг тасралтгүй хөгжүүлэх
          </li>
          <li>
            Төлбөр баталгаажуулах, гишүүнчлэлийн эрхийг найдвартай, шуурхай
            идэвхжүүлэх
          </li>
        </ul>
        <ol start="2">
          <li>
            Вэбсайт болон аппликэйшн нь өдөр бүр 24 цагийн ажиллагаатай байх
            бөгөөд шаардлага гарч түр хугацаанд хаагдах эсвэл засвар хийгдэх
            тохиолдолд систем хариуцсан ажилтан ажлын цагаар боломжит дээд
            хугацаанд засварлах үүрэгтэй.
          </li>
          <li>
            3.&nbsp;Бүртгэлтэй хэрэглэгчдийн хувийн мэдээлэл, төлбөр төлөлт
            болон бүх төрлийн нууцлалыг хоёр тал бүрэн хариуцна.
          </li>
          <li>
            4.&nbsp;Динамик платформ сайт болон аппликейшний бүтээгдэхүүн,
            үйлчилгээ, контент, мэдээллүүд нь үйлчилгээ үзүүлэгчийн өмч бөгөөд,
            зөвшөөрөгдсөнөөс бусад тохиолдолд хуулах, тараах, олшруулах, албан
            зөвшөөрөлгүй ашиглахыг хориглоно.
          </li>
        </ol>
        <p>ГУРАВ. ХЭРЭГЛЭГЧИЙН ЭРХ, ҮҮРЭГ</p>
        <ol>
          <li>
            Өөрийн платформд нэвтрэх хаяг, хувийн мэдээлэл болон нууц үгийг
            чандлан хадгалах, бусдад дамжуулахгүй байх үүрэгтэй.
          </li>
          <li>
            Динамик платформын үйл ажиллагааг илүү сайжруулах, боловсронгуй
            болгохтой холбоотой санал хүсэлтээ илэрхийлэх эрхтэй.
          </li>
          <li>
            Хэрэглэгч нь контент үзэх платформыг ашиглах тоног төхөөрөмж,
            интернэтээр өөрийгөө хангах үүрэгтэй.
          </li>
          <li>
            Платформд байршиж буй контентуудыг тараан байршуулах, хуулбарлахгүй
            байх үүрэгтэй.
          </li>
          <li>
            Бүх хэрэглэгчид тэгш эрх, үүрэгтэй байх бөгөөд ямар нэгэн хэрэглэгч
            бусад хэрэглэгчээс илүү давамгай эрхгүй.
          </li>
          <li>
            Платформ ашиглахад тулгарч буй асуудлуудыг тухай бүрд мэдээллэн
            зөвлөгөө, тусламж авах эрхтэй.
          </li>
        </ol>
      </div>
    </b-modal>
    <!-- container -->
  </div>
</template>

<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Select, Option, Notification, Message } from "element-ui";
import { mapActions } from "vuex";
import { localSave, localRead } from "@/libs/util";
import { hasOneOf } from "@/libs/tools";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    Select,
    Option,
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    departCascader2: () => ({
      component: import("@/components/modules/hr/departCascader2"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      registerHelpModal: false,
      showRegFromHomeSettings: false,
      depParentId: null,
      departs: [],
      dpOther: false,
      tmzExam: false,
      hideForm: false,
      hideRegister: false,
      privacyPolicy: false,
      tempQualityPerc: false,
      privacyPolicyModal: false,
      form: {
        userOvog: "",
        userNer: "",
        userUtas: "",
        userMail: "",
        userMailRe: "",
        userMailOwn: "",
        userLogin: "",
        userPass: "",
        userRegister: "",
        userRegA: "",
        userRegB: "",

        userAddress: "",
        userPosition: "",

        isLearning: false,
        isGereet: false,
        isGereetAndOrganization: false,
        isGereetMasker: true,
        isGereetAndAccountant: false,
        orgId: 0,

        profileModel: {
          departId: null,
          locTypeId1: null,
          locTypeId3: null,
          locTypeId4: null,
          locTypeId11: null,

          locTypeId13: null,
          locTypeId14: null,
          locTypeId15: null,

          i6: null,
          i7: null,
          s15: null,
          s6: null,
          s7: null,
          locTypeIds: [],
          qualityPerc: 0,
        },
      },
      crylChars: [
        "а",
        "б",
        "в",
        "г",
        "д",
        "е",
        "ё",
        "ж",
        "з",
        "и",
        "й",
        "к",
        "л",
        "м",
        "н",
        "о",
        "п",
        "р",
        "с",
        "т",
        "у",
        "ф",
        "х",
        "ц",
        "ч",
        "ш",
        "щ",
        "ъ",
        "ы",
        "ь",
        "э",
        "ю",
        "я",
      ],
    };
  },
  mounted() {
    require("@/assets/scss/pages/auth.scss");

    if (
      window.location.hostname == "members.cpta.mn" ||
      window.location.hostname == "192.168.0.105" ||
      window.location.hostname == "192.168.0.115" ||
      window.location.hostname == "172.20.10.3"
    ) {
      //this.showChoose= true;
      if (localRead("tmzExam") == "1") {
        this.tmzExam = true;
        this.hideForm = true;
        //this.setState(2);
        //this.form.isGereet= true;
        this.form.profileModel.locTypeIds = [142047];
        window.localStorage.removeItem("tmzExam");
      }
      // else{
      //   this.setState(1);
      // }
    }

    if (
      this.$store.state.app.activeGroup.id == 9265 ||
      this.$store.state.app.activeGroup.id == 9254 ||
      this.$store.state.app.activeGroup.id == 9311 ||
      this.$store.state.app.activeGroup.id == 9260
    ) {
      this.initDeparts();
    } else if (this.$store.state.app.activeGroup.id == 9226) {
      this.hideRegister = true;
    } else if (this.$store.state.app.activeGroup.id == 9298) {
      //this.hideRegister= 164717;
      this.hideRegister = true;
      this.form.profileModel.locTypeId4 = 164717;
    }

    // console.log("hi 1");

    request({
      api: { method: "GET", url: "User/GetHomeSettingsByKey" },
      //key: this.$store.state.app.activeGroup.key,
      params: { key: this.$store.state.app.activeGroup.key },
      store: this.$store,
    }).then((res) => {
      if (res != false) {
        // let arr = res.settings.filter((x) => x.key == "homeSetting_cover");
        // //console.log('res', res, arr);
        // if (arr.length > 0 && arr[0].value.length > 0) {
        //   this.coverObj.rdy = true;
        //   this.coverObj.url = arr[0].value;
        // }else{
        //   this.coverObj.fetched= true;
        // }

        let sttlgn = res.settings.filter(
          (x) => x.key == "homeSetting_register"
        );
        // console.log('res', res, sttlgn);
        if (sttlgn.length > 0 && sttlgn[0].value == "1") {
          // console.log('iishee orsnu');
          // this.showRegFromHomeSettings = true;
          this.showRegFromHomeSettings = (sttlgn[0].value == "1");
        }
      }
    });

    //  else if (this.$store.state.app.activeGroup.id == 9298) {
    //   this.form.profileModel.locTypeId4= 164717;
    // }
  },
  methods: {
    validateIsCryllic(event) {
      const cyrillicPattern = /^[\u0400-\u04FF\s\-]*$/;

      // Validate the input value
      if (cyrillicPattern.test(this.form[event])) {
        // this.isValid = true;
      } else {
        Message({
          message: "Зөвхөн крилл үсэг бичих боломжтой !",
          type: "warning",
        });
        // this.isValid = false;
        // Optionally, remove non-Cyrillic characters from input
        this.form[event] = this.form[event].replace(/[^А-Яа-я\s]/g, "");
      }
    },
    validateProfileIsCryllic(event) {
      const cyrillicPattern = /^[\u0400-\u04FF\s]*$/;

      // Validate the input value
      // console.log('cyrillicPattern.test(this.profileModel[event])', cyrillicPattern.test(this.form.profileModel[event]));
      if (cyrillicPattern.test(this.form.profileModel[event])) {
        // this.isValid = true;
      } else {
        Message({
          message: "Зөвхөн крилл үсэг бичих боломжтой !",
          type: "warning",
        });
        // this.isValid = false;
        // Optionally, remove non-Cyrillic characters from input
        this.form.profileModel[event] = this.form.profileModel[event].replace(
          /[^А-Яа-я\s]/g,
          ""
        );
      }
    },
    validateEmail() {
      const cyrillicRegex = /[\u0400-\u04FF]/;
      this.hasCyrillic = cyrillicRegex.test(this.form.userMail);
      if (this.hasCyrillic) {
        this.form.userMail = this.form.userMail.replace(cyrillicRegex, "");
        Message({
          message: "И-мэйл хаягт крилл үсэг бичих боломжгүй !",
          type: "warning",
        });
      }
    },
    isStartUp() {
      if (
        hasOneOf(
          ["startup.stf.gov.mn"],
          this.$store.state.app.activeGroup.hostPro
        ) &&
        this.$store.state.app.activeGroup.id == 9298
      ) {
        return true;
      } else return false;
    },
    ...mapActions(["handleLoading"]),
    getLoginLabel() {
      let rv = "Нэвтрэх нэр";
      if (this.$store.state.app.activeGroup.id == 9298) {
        rv = "Иргэний бүртгэлийн дугаар";
      }
      return rv;
    },
    exmLogin() {
      localSave("exmLogin", 1);
      this.$router.push({ name: "login" });
    },
    validateRegister(event) {
      if (event.charCode >= 48 && event.charCode <= 57) return true;
      else event.preventDefault();
    },
    validateRegisterForm() {
      if (!this.privacyPolicy) {
        Message({
          message: "Үйлчилгээний нөхцөл зөвшөөрнө үү.",
          type: "warning",
        });
        return false;
      }
      if (
        this.$store.state.app.activeGroup.id == 9265 ||
        this.$store.state.app.activeGroup.id == 9254 ||
        this.$store.state.app.activeGroup.id == 9311
      ) {
        if (this.form.userLogin == "") {
          Message({
            message: "Нэвтрэх нэр оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userMail == "") {
          Message({
            message: "И-мэйл хаяг оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userOvog == "") {
          Message({
            message: "Эцэг/эх-н нэр оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userNer == "") {
          Message({
            message: "Нэр оруулна уу",
            type: "warning",
          });
          return false;
        }
        // else if (this.form.userRegA == "") {
        //   Message({
        //     message: "Регистрийн дугаарын эхний үсгийг оруулна уу",
        //     type: "warning",
        //   });
        //   return false;
        // } else if (this.form.userRegB == "") {
        //   Message({
        //     message: "Регистрийн дугаарын 2 дахь үсгийг оруулна уу",
        //     type: "warning",
        //   });
        //   return false;
        // } else if (
        //   this.form.userRegister == "" ||
        //   this.form.userRegister.length < 8
        // ) {
        //   Message({
        //     message: "Регистрийн дугаарын 8 оронг оруулна уу",
        //     type: "warning",
        //   });
        //   return false;
        // }
        else if (
          this.form.profileModel.locTypeId1 <= 0 ||
          this.form.profileModel.locTypeId1 == null
        ) {
          Message({
            message: "Хүйс сонгоно уу",
            type: "warning",
          });
          return false;
        } else if (
          this.form.profileModel.departId <= 0 ||
          this.form.profileModel.departId == null
        ) {
          Message({
            message: "Байгууллага сонгоно уу",
            type: "warning",
          });
          return false;
        } else if (
          (this.form.profileModel.s6 == "" ||
            this.form.profileModel.s6 == null) &&
          this.dpOther
        ) {
          Message({
            message: "Одоо ажиллаж буй ажлын газрын нэр оруулна уу",
            type: "warning",
          });
          return false;
        } else if (
          this.form.profileModel.s7 == "" ||
          this.form.profileModel.s7 == null
        ) {
          Message({
            message: "Газар/Хэлтэс/Алба оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userPosition == "") {
          Message({
            message: "Албан тушаал оруулна уу",
            type: "warning",
          });
          return false;
        } else if (
          (this.form.profileModel.locTypeId11 <= 0 ||
            this.form.profileModel.locTypeId11 == null) &&
          this.$store.state.app.activeGroup.id == 9265
        ) {
          Message({
            message: "Түвшин сонгоно уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userUtas == "" || this.form.userUtas.length < 8) {
          Message({
            message: "8 оронтой утасны № оруулна уу",
            type: "warning",
          });
          return false;
        } else return true;
      } else {
        if (this.form.userRegA == "" && !this.hideRegister) {
          Message({
            message: "Регистрийн дугаарын эхний үсгийг оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userRegB == "" && !this.hideRegister) {
          Message({
            message: "Регистрийн дугаарын 2 дахь үсгийг оруулна уу",
            type: "warning",
          });
          return false;
        } else if (
          (this.form.userRegister == "" || this.form.userRegister.length < 8) &&
          !this.hideRegister
        ) {
          Message({
            message: "Регистрийн дугаарын 8 оронг оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userOvog == "") {
          Message({
            message: "Эцэг/эх-н нэр оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userNer == "") {
          Message({
            message: "Нэр оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userUtas == "" || this.form.userUtas.length < 8) {
          Message({
            message: "8 оронтой утасны № оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userLogin == "") {
          Message({
            message: this.getLoginLabel() + " оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userMail == "") {
          Message({
            message: "И-мэйл хаяг оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userMailRe == "") {
          Message({
            message: "И-мэйл хаяг давтан оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userMail != this.form.userMailRe) {
          Message({
            message: "И-мэйл хаяг зөв давтан оруулна уу",
            type: "warning",
          });
          return false;
        } else return true;
      }
    },
    initDeparts() {
      this.handleLoading({ isLoading: true });

      let _pid = null;
      if (this.$store.state.app.activeGroup.id == 9265) {
        _pid = 19875;
      } else if (this.$store.state.app.activeGroup.id == 9254) {
        _pid = 18372;
        this.depParentId = _pid;
      } else if (this.$store.state.app.activeGroup.id == 9311) {
        _pid = 28885;
      } else if (this.$store.state.app.activeGroup.id == 9260) {
        _pid = 19267;
      }

      request({
        api: { method: "GET", url: "hr/getDepartTreeData" },
        params: {
          parentId: _pid,
          geChild: false,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          // console.log('res.data.departs', res.data.departs);
          this.departs = res.data.departs;
        }
      });
    },
    showPrivacyPolicy() {
      this.privacyPolicyModal = true;
    },
    register() {
      //console.log('this.profileModel', this.profileModel);
      if (this.validateRegisterForm()) {
        if (this.tempQualityPerc) {
          this.form.profileModel.qualityPerc = 1;
        }

        this.handleLoading({ isLoading: true });
        request({
          api: { method: "POST", url: "User/RegisterByToken" },
          data: {
            userOvog: this.form.userOvog,
            userNer: this.form.userNer,
            userUtas: this.form.userUtas,
            userMail: this.form.userMail,
            userMailOwn: this.form.userMailOwn,
            userLogin: this.form.userLogin,
            userPass: this.form.userPass,
            userRegister:
              this.form.userRegA +
              "" +
              this.form.userRegB +
              "" +
              this.form.userRegister,
            isLearning: this.form.isLearning,
            isGereet: this.form.isGereet,
            isGereetOrg: this.form.isGereetAndOrganization,
            partnerId: this.form.orgId,
            //dta: this.dta

            address: this.form.userAddress,
            position: this.form.userPosition,
            profileModel: this.form.profileModel,
            privacyPolicy: this.privacyPolicy,
          },
          store: this.$store,
        }).then((res) => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            if (
              this.$store.state.app.activeGroup.id == 9241 ||
              this.$store.state.app.activeGroup.id == 9249
            ) {
              Notification.success({
                message:
                  "Таны бүртгэл амжилттай үүслээ. Байгууллага хариуцсан мэргэжилтэн баталгаажуулах хүртэл түр хүлээнэ үү.",
                title: "Амжилттай",
                duration: 60000,
                type: "success",
                position: "top-right",
                offset: 50,
              });
              this.$router.push({ name: "login" });
            } else {
              Notification.success({
                message:
                  "Таны бүртгэл амжилттай үүслээ. Таны и-мэйл хаягаар очсон баталгаажуулах кодыг оруулна уу.",
                title: "Амжилттай",
                duration: 30000,
                type: "success",
                position: "top-right",
                offset: 50,
              });
              localSave("activationGroupId", res.mailRenew.groupId);
              localSave("activationUserId", res.mailRenew.userId);
              this.$router.push({
                name: "activation",
                params: { u: res.mailRenew.userId },
              });
            }
          }
        });
      }
    },
    locTypeId4Changed(e) {
      if (e > 0) {
        this.hideForm = false;
      } else {
        this.hideForm = true;
      }
    },
    departChanged(e, level2, departsFlat2) {
      let _dt = this.departs.filter((x) => x.id == e);
      if (_dt.length && _dt[0]["shortName"] == "other") {
        this.dpOther = true;
        if (level2 != undefined) {
          this.form.profileModel.departId = e;
        }
      } else {
        if (level2 != undefined) {
          this.form.profileModel.departId = null;
        }
        this.dpOther = false;
      }

      if (level2 != undefined && level2) {
        let _dt2 = departsFlat2.filter((x) => x.id == e);
        if (_dt2.length && _dt2[0]["shortName"] == "other") {
          this.dpOther = true;
        } else {
          this.dpOther = false;
        }

        this.form.profileModel.departId = e;
      }
    },
  },
};
</script>
